'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import Cookies from 'js-cookie';
import validation from './validation';

// ----------------------------------------
// Private
// ----------------------------------------

let triggerBuffer = [];
let popupOpen = false;

function showPopup () {
	$.ajax({
		url: '/popup/autoform',
		type: 'post',
		data: {
			id: triggerBuffer.shift()
		},
		success: function (response) {
			if (response) {
				let $html = $(response);
				$.magnificPopup.open({
					items: {
						src: $html
					},
					type: 'inline',
					removalDelay: 300,
					mainClass: 'zoom-in',
					closeBtnInside: true,
					autoFocusLast: false,
					fixedContentPos: false,
					callbacks: {
						open: function () {
							validation('.js-form', $html);
						},
						afterClose: function () {
							if (triggerBuffer.length) {
								setTimeout(function () {
									showPopup();
								}, 1000);
							} else {
								popupOpen = false;
							}
						}
					}
				});
			}
		}
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

function trigger () {
	$('.js-trigger').each(function () {
		let el = this;
		let $el = $(el);
		let id = this.id;

		if (id) {
			let observer;
			if (window.IntersectionObserver) {
				observer = new window.IntersectionObserver(function (entries) {
					if (entries[0].isIntersecting && !$el.data('trigger')) {
						$el.data('trigger', true);
						triggerBuffer.push(id);
						if (!popupOpen && triggerBuffer.length) {
							popupOpen = true;
							showPopup();
						}
					}
				}, {
					rootMargin: '0px',
					threshold: 0
				});
				observer.observe(el);
			} else {
				triggerBuffer.push(id);
				if (!popupOpen && triggerBuffer.length) {
					popupOpen = true;
					showPopup();
				}
			}
		}
	});

	$('.js-trigger-click').each(function () {
		const el = this;
		const $this = $(el);
		const timeout = $this.data('timeout');
		const cookie = $this.data('cookie');
		const isObserver = $this.data('observer');
		const ns = $this.data('ns');

		const showTimeout = function (func) {
			if (timeout) {
				setTimeout(function () {
					func();
				}, timeout);
			} else {
				func();
			}
		};

		const showObserver = function (func) {
			if (isObserver && window.IntersectionObserver) {
				const observer = new window.IntersectionObserver(function (entries) {
					if (entries[0].isIntersecting && !$this.data('is-observed')) {
						$this.data('is-observed', true);
						func();
					}
				}, {
					rootMargin: '0px',
					threshold: 0
				});
				observer.observe(el);
			} else {
				func();
			}
		};

		const showCookie = function (func) {
			if (cookie) {
				if (!Cookies.get(cookie)) {
					func();
				}
			} else {
				func();
			}
		};

		const showNs = function (func) {
			if (ns) {
				if (!$(`[data-ns="${ns}"].js-trigger-click.is-triggered`).length) {
					func();
				}
			} else {
				func();
			}
		};

		if (!$.magnificPopup.instance.isOpen) {
			showCookie(function () {
				showObserver(function () {
					showTimeout(function () {
						showNs(function () {
							$this.addClass('is-triggered');
							$this.trigger('click');
						});
					})
				})
			});
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {
	trigger
};



// WEBPACK FOOTER //
// ./src/js/_modules/trigger.js